export const EnumLanguage = {
  EN: 'en',
};
